import { render, staticRenderFns } from "./FundDetails.vue?vue&type=template&id=42e33f31&"
import script from "./FundDetails.vue?vue&type=script&lang=js&"
export * from "./FundDetails.vue?vue&type=script&lang=js&"
import style0 from "./FundDetails.vue?vue&type=style&index=0&id=42e33f31&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports